module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dc890db78d2e7ac9b4bee95649e0d8e8.png";